import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary, postData } from './components/misc';
import './customAlert';

const version = "1.0.2"; // Version of the app
const hostname = window.location.hostname || "";

function getSiteTitle() {
  if (hostname.includes("penzi-halisi.com")) {
    return "Penzi Halisi";
  }

  if (/(^|\.)upendo-halisi\.com$/i.test(hostname)) {
    return "Upendo Halisi";
  }

  return "Expat Elite Singles";
}

document.title = getSiteTitle();
// 🌍 Global error handlers
window.onerror = function (message, source, lineno, colno, error) {
  postData('/api/log-error', {
      type: `GlobalError ${version}`,
      message,
      source,
      lineno,
      colno,
      stack: error?.stack || null,
  }).catch((error) => {
    console.log('Error logging: ', error);
  });
};

window.onunhandledrejection = function (event) {
  postData('/api/log-error', {
      type: `UnhandledPromiseRejection ${version}`,
      reason: event.reason?.message || String(event.reason),
  }).catch((error) => {
    console.log('Error logging unhandled rejection:', error);
  });
};

const rootElement = document.getElementById('mainrender');
// Create a root using ReactDOM's createRoot (new in React 18)
const root = ReactDOM.createRoot(rootElement);

// Render the App component inside the root element
root.render(
  <React.StrictMode>
    <ErrorBoundary version={version}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
